import classNames from 'classnames';
import noop from 'lodash/noop';
import React from 'react';

import Dropdown from '@commons/Dropdown/Simple';

import { isDropdownAccessibilityEnabled } from '@services/featureFlags';

import styles from './languageDropdown.scss';

interface LanguageDropdownProps {
  isCookieBannerOpened: boolean;
  languages?: {
    name?: string;
    key?: string;
  }[];
  surveyLanguage?: string;
  label?: string;
  onLanguageSelected?: (...args: unknown[]) => unknown;
}

const LanguageDropdown = ({
  isCookieBannerOpened,
  languages = [],
  surveyLanguage = 'en',
  onLanguageSelected = noop,
  label = ''
}: LanguageDropdownProps) => {
  const dropdownList = languages.map((lang) => ({
    text: lang.name,
    id: lang.key,
    langKey: lang.key,
    active: lang.active
  }));
  const optionSelected = dropdownList.find((lang) => lang.id === surveyLanguage);
  const shouldRender = dropdownList.length > 1;
  const elementIdObject = isDropdownAccessibilityEnabled()
    ? { elementId: 'language-dropdown' }
    : {};
  const containerStyles = classNames({
    [styles.dropdown_withCookieBanner]: isCookieBannerOpened
  });

  if (!shouldRender) {
    return null;
  }

  return (
    <Dropdown
      containerStyles={containerStyles}
      dropdownList={dropdownList}
      selected={optionSelected}
      onChange={onLanguageSelected}
      label={label}
      isDropdownLabelInactive={!isDropdownAccessibilityEnabled()}
      selectByWordWhenIsOpenOnly={isDropdownAccessibilityEnabled()}
      {...elementIdObject}
    />
  );
};

export default LanguageDropdown;
